import { Badge, BadgeProps } from "antd";

const ReferenceBadge: React.FC<BadgeProps> = ({
    children,
}) => {
    return (
        <Badge
            count={children}
            style={{
                backgroundColor: 'var(--grey-400)',
                height: '1.1rem',
                minWidth: '1.1rem',
                lineHeight: '1.1rem',
                fontSize: '10px',
                marginBottom: '3px',
                borderRadius: '100vmax',
                boxShadow: 'none'
            }}
        />
    );
};

export default ReferenceBadge;
